import { DataType } from 'components/table/types';
import { customerActivityTypes } from 'constants/customer-account.constants';

export type tableColumns = Record<customerActivityTypes, Record<string, DataType>>;
export const tableColumns: tableColumns = {
	[customerActivityTypes.MONEY_ACTIVITIES]: {
		createdAt: 'date',
		createdBy: 'string',
		// settlementDate: 'date',
		approverName: 'string',
		typeHebrew: 'custom',
		sumAndCurrency: 'string',
		currencyName: 'string',
		//feeAndCurrency: 'custom',
		statusHebrew: 'string',
		reference: 'string',
	},
	[customerActivityTypes.CONTACTS]: {
		createdAt: 'date',
		firstName: 'string',
		lastName: 'string',
		role: 'string',
		permissionHebrew: 'string',
		maxForConvert: 'number',
		maxForPayment: 'number',
		statusHebrew: 'string',
		reference: 'string',
	},
	[customerActivityTypes.BENEFICIARIES]: {
		createdAt: 'date',
		companyName: 'custom',
		customNickname: 'string',
		typeHebrew: 'string',
		countryName: 'string',
		paymentTypeHebrew: 'string',
		statusHebrew: 'string',
		subStatus: 'custom',
		lastPayment: 'date',
		lastUpdatedByBoUser: 'custom',
		reference: 'string',
		edit: 'custom',
	},
	[customerActivityTypes.BANK_ACCOUNTS]: {
		accountOwnerName: 'string',
		bankName: 'string',
		bankCode: 'string',
		bankBranch: 'string',
		accountNumber: 'string',
		statusHebrew: 'string',
		reference: 'string',
	},
	[customerActivityTypes.SUPPORT_REQUESTS]: {
		createdAt: 'date',
		subject: 'string',
		amount: 'integer',
		currency: 'string',
		message: 'custom',
		status: 'custom',
		updatedAt: 'date',
		updatedBy: 'string',
		boNotes: 'string',
	},
	[customerActivityTypes.ACCOUNTS_IN_PROCESS]: {
		entityType: 'string',
		identificationNumber: 'string',
		accountNameHebrew: 'string',
		accountNameEnglish: 'string',
		maxForPayment: 'string',
		maxForConver: 'string',
		currentStep: 'string',
	},
	[customerActivityTypes.WAITING_FOR_APPROVAL]: {
		entityType: 'string',
		identificationNumber: 'string',
		accountNameHebrew: 'string',
		accountNameEnglish: 'string',
		maxForPayment: 'string',
		maxForConver: 'string',
	},
	[customerActivityTypes.ACCOUNTS_DECLINED]: {
		entityType: 'string',
		identificationNumber: 'string',
		accountNameHebrew: 'string',
		accountNameEnglish: 'string',
		maxForPayment: 'string',
		maxForConver: 'string',
		reviewerComment: 'string',
	},
};

export enum activityTypeEnum {
	PAYMENT = 'Payment',
	PAYMENT_FEE = 'PaynentFee',
	BALANCE_ADDITION = 'Balance',
	BALANCE_WITHDRAWAL = 'BalanceWithdrawal',
	CONVERSION = 'Conversion',
	CONVERSION_FEE = 'ConversionFee',
	BALANCE_REFUND = 'BalanceRefund',
}

export enum beneficiaryTypeEnum {
	COMPANY = 'Company',
	INDIVIDUAL = 'Individual',
}

export enum beneficiaryPaymentTypeEnum {
	REGULAR = 'Regular',
	PRIORITY = 'Priority',
}

export enum generalSelectionEnum {
	ALL = 'all',
}

export enum beneficiaryRiskType {
	LOW = 'low',
	MEDIUM = 'medium',
	HIGH = 'high',
	VERY_HIGH = 'veryHigh',
}
